import { TimelineMax } from 'gsap'
import CSSRulePlugin from 'gsap/CSSRulePlugin'
import ScrollMagic from 'scrollmagic'
import 'animation.gsap'
// import 'debug.addIndicators' // debug

// *
// * TimelineMax().to({element}, Number(Duration), {options}, Number(Delay))
// *

// intro animation
const loadTween = () => {
  let tl = new TimelineMax()

  tl
  .set([
    '#js-magicLoadTween-init',
    '#js-magicLoadTween-first',
    '#js-magicLoadTween-second'
  ], {
    autoAlpha: 0
  })
  .set('#js-magicLoadTween-third', {
    autoAlpha: 0,
    bottom: '5%'
  })
  .to('#js-magicLoadTween-init', 1, {
    autoAlpha: 1,
    ease: 'easeOutExpo'
  })
  .to([
    '#js-magicLoadTween-first',
    '#js-magicLoadTween-second'
  ], 1, {
    autoAlpha: 1,
    ease: 'easeOutExpo'
  }, '-=0.2')
  .to('#js-magicLoadTween-third', 1, {
    autoAlpha: 1,
    bottom: 0,
    ease: 'easeInOutExpo'
  }, '-=0.5')
}

// scrollmagic
const ScrollMagicScene = () => {
  const ctrlLeave = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 'onLeave'
    }
  })

  const ctrlCenter = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 'onCenter'
    }
  })

  const magicAfterCSS = CSSRulePlugin.getRule('.ty-Magic-bg:after')

  // Bg
  new ScrollMagic.Scene({
    duration: '200%',
    triggerElement: '.ty-Magic-bg'
  })
  .setPin('.ty-Magic-bg') // 指定した要素を留める
  // .addIndicators({name: 'Bg'}) // debug
  .addTo(ctrlLeave)

  // Overlay
  new ScrollMagic.Scene({
    duration: '100%'
  })
  .setTween(new TimelineMax().to(magicAfterCSS, 1, {
    backgroundColor: 'rgba(000, 000, 000, .8)'
  }))
  // .addIndicators({name: 'Overlay'}) // debug
  .addTo(ctrlLeave)

  // sean1
  new ScrollMagic.Scene({
    duration: '50%'
  })
  .setTween(
    new TimelineMax().to('.ty-Magic-content-sean1', 1, {
      opacity: 0
    })
  )
  // .addIndicators({name: 'sean1'}) // debug
  .addTo(ctrlCenter)

  // sean2
  new ScrollMagic.Scene({
    duration: '112%',
    triggerElement: '.ty-Magic-content-sean2'
  })
  .setTween(
    new TimelineMax()
    .to('.ty-Magic-content-sean2', 1, {
      opacity: 1
    })
  )
  .setPin('.ty-Magic-content-sean2') // 指定した要素を留める
  // .addIndicators({name: 'sean2'}) // debug
  .addTo(ctrlCenter)
}

const businessAnim = () => {
  $('.ty-Magic-bg').imagesLoaded({ background: true }, () => {
    loadTween()
    ScrollMagicScene()
  })
}

// sean1をセンターへ
export function setSean1 () {
  const wh = $(window).height()
  const $sean1 = $('.ty-Magic-content-sean1')
  const sean1Height = $sean1.height()

  $sean1.css({
    'margin-top': `${wh - sean1Height}px`
  })
}

export default businessAnim



// WEBPACK FOOTER //
// ./src/js/lib/business-anim.js